<h2 class="text-center"> Billing Rates</h2>
<div class="table-responsive" *ngIf="!loadingBillingCharts">
  <table datatable  [dtOptions]="dtOptions" class="row-border hover table table-striped display compact">
    <thead>
    <tr>
    <td>Alpha2</td>
    <th>Base Week(UGX)</th>
    <th>Base Month(UGX)</th>
    <th>Base Year(UGX)</th>

    <th>Rated Week</th>
    <th>Rated Month</th>
    <th>Rated Year</th>
    <th>Mobile Money</th>
    <th>Currency</th>
    <th>Country</th>
    <th>Dollar</th>
    <th></th>
    </tr>
    </thead>

    <tbody>

    <tr *ngFor="let billingItem of billingList;">
        <td>{{billingItem['alpha2']}}</td>
        <td>{{billingItem['baseWeek']}}</td>
        <td>{{billingItem['baseMonth']}}</td>
        <td>{{billingItem['baseYear']}}</td>

        <td>{{billingItem['week']}}</td>
        <td>{{billingItem['month']}}</td>
        <td>{{billingItem['year']}}</td>
        <td>{{billingItem['mobileMoneyYes']}}</td>
        <td>{{billingItem['currency']}}</td>
        <td>{{billingItem['countryName']}}</td>
        <td>{{billingItem['dollar']}}</td>
        <td>
            <a *ngIf="billingItem['id']!=0"
                [routerLink]="['/admin/billing/show/',billingItem['id']]" >
                Edit Dollar Rate</a>

        </td>
    </tr>
    </tbody>

</table>
</div>
<h2 class="text-center"> Base Rate</h2>

<div class="text-center">
  <span *ngIf="loadingBillingCharts" class="spinner-border spinner-border-sm me-1"></span>
</div>
<div class="text-center" *ngIf="!loadingBaseRate" >

  <table *ngIf="baseRate" class="table table-responsive table-striped">
    <tr>
      <td>Week</td><td>{{baseRate.week}} UGX</td>
    </tr>
    <tr>
      <td>Month</td><td>{{baseRate.month}} UGX</td>
    </tr>
    <tr>
      <td>Year</td><td>{{baseRate.year}} UGX</td>
    </tr>
  </table>
  <a *ngIf="baseRate['id']!=0"
                [routerLink]="['/admin/billing/base/rate/show/',baseRate['id']]" >
                Edit Base Rate</a>
</div>
<div class="text-center">
  <span *ngIf="loadingBaseRate" class="spinner-border spinner-border-sm me-1"></span>
</div>


